import Entity from "./entity";
import Option from "./option";
import Allergen from "./allergen";

/**
 * Object representation for a Product document from the database.
 */
class Product extends Entity {
  constructor({
    id,
    restaurantId,
    allergens,
    name,
    image,
    banner,
    description,
    price,
    category,
    options,
    index,
    visibility
  } = {}) {
    super({ id: id, restaurantId: restaurantId });
    this.allergens = allergens;
    this.name = name;
    this.image = image;
    this.banner = banner;
    this.description = description;
    this.price = price;
    this.category = category;
    this.options = options;
    this.index = index;
    this.visibility = visibility === false ? visibility : true;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    let map = {
      id: this.id,
      allergens: this.allergens
        ? this.allergens.map(allergen => allergen.toMap())
        : [],
      name: this.name,
      image: this.image,
      banner: this.banner,
      description: this.description,
      price: this.price,
      category: this.category,
      options: this.options ? this.options.map(option => option.toMap()) : [],
      index: this.index,
      visibility: this.visibility
    };

    return map;
  }

  /**
   * @param {*} snapData Product document data as a plain JS object
   * snapshot represented by this `Product`.
   * @returns {Product} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    // Parse options if any
    snapData.options = snapData.options
      ? snapData.options.map(option => Option.fromMap(option))
      : [];

    // // Parse allergens if any
    snapData.allergens = snapData.allergens
      ? snapData.allergens.map(allergen => Allergen.fromMap(allergen))
      : [];

    return new Product(snapData);
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `Product` belongs to.
   */
  get _functionUrl() {
    return "products";
  }

  get _collectionName() {
    return `products`;
  }

  get _entityName() {
    return "product";
  }
}

export default Product;
